import { parse, getHours, getMinutes } from 'date-fns';

import { SANS_TOPU } from 'Store/constants/sportTypes';
import EnvironmentManager from 'Utils/environmentManager';

export const cgDrawHours = value => {
  if (value && isNaN(value)) {
    const date = parse(value, "yyyy-MM-dd'T'HH:mm", new Date());
    let hours = getHours(date) < 10 ? `0${getHours(date)}` : getHours(date);
    let minutes = getMinutes(date) < 10 ? `0${getMinutes(date)}` : getMinutes(date);

    return `${hours}:${minutes}`;
  }
};

export const cgSlipSelectionTextFormatter = (gameType, selections = [], extraSelection = [], withSpace = false) => {
  let text = '';

  selections.sort((a, b) => a - b);

  if (gameType === SANS_TOPU) {
    selections.forEach((number, index) => {
      const additionalString = withSpace ? ' - ' : '-';

      text = index === 0 ? text + number : text + additionalString + number;
    });

    if (extraSelection?.length) {
      const additionalString = withSpace ? ' + ' : '+';

      text = text + additionalString + extraSelection[0];
    }

  } else {
    selections.forEach((number, index) => {
      const additionalString = withSpace ? ' - ' : '-';

      text = index === 0 ? number : text + additionalString + number;
    });
  }

  return text;
};

export const generateRandomNumbers = (selections, startNumber, endNumber, maxDigitForColumn) => {
  let numbers = [];
  
  // Change numbers if the selectios array is full.
  if (selections.length === maxDigitForColumn) {
    for (let i = 0; i < maxDigitForColumn; i++) {
      let generatedNumber;
  
      do {
        generatedNumber = Math.floor(Math.random() * ((endNumber + 1) - startNumber) + startNumber);
      } while (numbers.some(number => number === generatedNumber));
  
      numbers.push(generatedNumber);
    }
  } else {
    // Change rest of the selections array when it is not full.
    for (let i = 0; i < maxDigitForColumn; i++) {
      if (typeof selections[i] === 'number') {
        numbers.push(selections[i]);
      } else {
        let generatedNumber;
  
        do {
          generatedNumber = Math.floor(Math.random() * ((endNumber + 1) - startNumber) + startNumber);
        } while (numbers.some(number => number === generatedNumber));
  
        numbers.push(generatedNumber);
      }
    }
  }

  return numbers;
};

export const generateRandomNumber = (startNumber = 1, endNumber = 14) => {
  return [Math.floor(Math.random() * ((endNumber + 1) - startNumber) + startNumber)];
};

export const getPlayableColumnsInfo = (selections = [], gameType, rules = {}) => {
  let isReadyForPlay = true;
  let columns = [];

  if (gameType === SANS_TOPU) {
    selections.forEach(item => {
      if (item.selection.length === rules.maxDigitForColumn && item.extraSelection.length === rules.extra.maxDigitForColumn) {
        columns.push(item);
      }

      if ((item.selection.length || item.extraSelection.length) && (item.selection.length !== rules.maxDigitForColumn || item.extraSelection.length !== rules.extra?.maxDigitForColumn)) {
        isReadyForPlay = false;
      }

    });
  } else {
    selections.forEach(item => {
      if (item.selection.length === rules.maxDigitForColumn) {
        columns.push(item);
      }

      if ((item.selection.length && item.selection.length !== rules.maxDigitForColumn)) {
        isReadyForPlay = false;
      }
    });
  }

  return {
    columns,
    isReadyForPlay
  };
};

// Api parameters mapping
export const apiURLMapping = {
  'para-loto': 'DIGITAL_SUPER_LOTTERY',
  'sayisal-loto': 'DIGITAL_LOTTERY',
  'on-numara': 'LUCKY_TEN',
  'sans-topu': 'CHANCE_BALL'
};

export const gameTypeToTabName = {
  'para-loto': 'Para Loto',
  'sayisal-loto': 'Süper Sayısal Loto',
  'on-numara': 'Süper On Numara',
  'sans-topu': 'Süper Şans Topu'
};

export const selectionDescriptionMapping = {
  'para-loto': EnvironmentManager.getMessageText({ key: 'draws_super_loto_selection_desc' }) || '1’den 54’a kadar sayı kümesinde 6 sayı seçebilirsiniz.',
  'sayisal-loto': EnvironmentManager.getMessageText({ key: 'draws_sayisal_loto_selection_desc' }) || '1’den 49’a kadar sayı kümesinde 6 sayı seçebilirsiniz.',
  'on-numara': EnvironmentManager.getMessageText({ key: 'draws_on_numara_selection_desc' }) || '1’den 80’a kadar sayı kümesinde 10 sayı seçebilirsiniz.',
  'sans-topu': EnvironmentManager.getMessageText({ key: 'draws_sans_topu_selection_desc' }) || '1’den 34’a kadar sayı kümesinde 5 sayı seçebilirsiniz. İkinci alandan 1’den 14’e kadar 1 sayı seçebiliisiniz.'
};

export const tabNameMapping = {
  'devam-eden': 'PLAYED',
  kazanan: 'WON',
  kaybeden: 'LOST'
};

export const playCouponExceptionMessages = {
  'digital-lottery-mobile-bff4004': EnvironmentManager.getMessageText({ key: 'digital-lottery-mobile-bff4004' }),
  'digital-lottery-mobile-bff4003': EnvironmentManager.getMessageText({ key: 'digital-lottery-mobile-bff4003' }),
  'digital-lottery-mobile-bff4002': EnvironmentManager.getMessageText({ key: 'digital-lottery-mobile-bff4002' }),
  'digital-lottery-mobile-bff4001': EnvironmentManager.getMessageText({ key: 'digital-lottery-mobile-bff4001' }),
  'digital-lottery-api4004': EnvironmentManager.getMessageText({ key: 'digital-lottery-api4004' }),
  'digital-lottery-api4003': EnvironmentManager.getMessageText({ key: 'digital-lottery-api4003' }),
  'digital-lottery-api4002': EnvironmentManager.getMessageText({ key: 'digital-lottery-api4002' }),
  'digital-lottery-api4001': EnvironmentManager.getMessageText({ key: 'digital-lottery-api4001' }),
  'account-balance-api4004': EnvironmentManager.getMessageText({ key: 'account-balance-api4004' })
};

export const machinePlayMessages = {
  columnCount: EnvironmentManager.getMessageText({ key: 'draws_random_column_message' }) || 'Girdiğiniz kolon sayısına göre otomatik kupon oluşturur',
  amount: EnvironmentManager.getMessageText({ key: 'draws_random_amount_message' }) || 'Seçtiğiniz tutara göre otomatik kupon oluşturur',
  confirmMessage: EnvironmentManager.getMessageText({ key: 'draws_random_confirm_message' }) || '<p>Kuponunuzdaki kolonlar <b>silinerek,<br />Yeni kolonlar</b> eklenecektir.<br />Onaylıyor musunuz?</p>'
};

export const drawInfoImageURLMapping = {
  'para-loto': EnvironmentManager.getMessageText({ key: 'draws_para_loto_image_url' }),
  'sayisal-loto': EnvironmentManager.getMessageText({ key: 'draws_super_sayisal_loto_image_url' }),
  'on-numara': EnvironmentManager.getMessageText({ key: 'draws_super_on_numara_image_url' }),
  'sans-topu': EnvironmentManager.getMessageText({ key: 'draws_super_sans_topu_image_url' })
};

export const playTabCloseMessage = {
  'para-loto': 'Para Loto oyunumuz sona ermiştir. Çekiliş sonuçlarını, Para Loto sonuçlar sayfasında görebilirsin. Satın aldığın biletleri , biletlerimden takip  edebilirsin.',
  'sayisal-loto': 'Süper Sayısal Loto oyunumuz sona ermiştir. Çekiliş sonuçlarını, Süper Sayısal Loto sonuçlar sayfasında görebilirsin. Satın aldığın biletleri , biletlerimden takip  edebilirsin.',
  'on-numara': 'Süper On Numara oyunumuz sona ermiştir. Çekiliş sonuçlarını, Süper On Numara sonuçlar sayfasında görebilirsin. Satın aldığın biletleri , biletlerimden takip  edebilirsin.',
  'sans-topu': 'Süper Şans Topu oyunumuz sona ermiştir. Çekiliş sonuçlarını, Süper Şans Topu sonuçlar sayfasında görebilirsin. Satın aldığın biletleri , biletlerimden takip  edebilirsin.'
};

export const gameFinishDates = {
  'para-loto': new Date('2020-07-30T19:15:00'),
  'sayisal-loto': new Date('2020-07-29T19:45:00'),
  'on-numara': new Date('2020-07-31T20:15:00'),
  'sans-topu': new Date('2020-07-29T19:15:00')
};
